// extracted by mini-css-extract-plugin
export var currencyInput = "_ly-1";
export var currencySymbol = "_ly-0";